var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.center ? 'custom-loader-center' : 'custom-loader',staticStyle:{"margin-bottom":"100px"}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-border mt-10",attrs:{"role":"status"}},[_c('span',{staticClass:"visually-hidden"},[_vm._v("Loading...")])])
}]

export { render, staticRenderFns }